import { DynamicFormControlComponent, DynamicFormLayoutService, DynamicFormValidationService, DynamicFormControlContainerComponent, DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER, DYNAMIC_FORM_CONTROL_TYPE_INPUT, DYNAMIC_FORM_CONTROL_TYPE_SELECT, DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA, DynamicFormValueControlModel, DynamicFormComponentService, DynamicFormRelationService, DynamicTemplateDirective, DYNAMIC_FORM_CONTROL_TYPE_SWITCH, DYNAMIC_FORM_CONTROL_TYPE_SLIDER, DYNAMIC_FORM_CONTROL_TYPE_RADIO_GROUP, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX_GROUP, DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX, DYNAMIC_FORM_CONTROL_TYPE_ARRAY, DynamicFormArrayComponent, DynamicFormGroupComponent, DynamicFormComponent, DynamicFormsCoreModule } from '@ng-dynamic-forms/core';
import { EventEmitter, Component, Inject, Optional, Input, Output, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ComponentFactoryResolver, ContentChildren, HostBinding, ViewContainerRef, ViewChildren, NgModule } from '@angular/core';
import { MAT_RIPPLE_GLOBAL_OPTIONS, ErrorStateMatcher } from '@angular/material/core';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipsModule } from '@angular/material/chips';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-dynamic-forms/core';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/material/checkbox';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@angular/material/form-field';
import * as ɵngcc6 from '@angular/material/chips';
import * as ɵngcc7 from '@angular/material/input';
import * as ɵngcc8 from '@angular/material/autocomplete';
import * as ɵngcc9 from '@angular/material/icon';
import * as ɵngcc10 from '@angular/material/core';
import * as ɵngcc11 from '@angular/material/datepicker';
import * as ɵngcc12 from '@angular/material/radio';
import * as ɵngcc13 from '@angular/material/select';
import * as ɵngcc14 from '@angular/material/slide-toggle';
import * as ɵngcc15 from '@angular/material/slider';
import * as ɵngcc16 from '@angular/cdk/text-field';

const _c0 = ["matCheckbox"];
const _c1 = function (a0, a1) { return [a0, a1]; };
const _c2 = ["matAutocomplete"];
const _c3 = ["matChipList"];
function DynamicMaterialChipsComponent_mat_chip_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-chip", 8);
    ɵngcc0.ɵɵlistener("removed", function DynamicMaterialChipsComponent_mat_chip_3_Template_mat_chip_removed_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const chip_r4 = restoredCtx.$implicit; const index_r5 = restoredCtx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onChipRemoved(chip_r4, index_r5); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-icon", 9);
    ɵngcc0.ɵɵtext(4, "cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const chip_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("selectable", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(chip_r4);
} }
function DynamicMaterialChipsComponent_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", option_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r8);
} }
const _c4 = ["matDatepicker"];
function DynamicMaterialDatePickerComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 10);
    ɵngcc0.ɵɵelement(1, "mat-label", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.model.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialDatePickerComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.model.prefix, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialDatePickerComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.model.suffix, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialDatePickerComponent_mat_hint_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-hint", 14);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r3.model.hint, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialDatePickerComponent_mat_error_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r6);
} }
function DynamicMaterialInputComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 11);
    ɵngcc0.ɵɵelement(1, "mat-label", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.model.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialInputComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.model.prefix, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialInputComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 14);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.model.suffix, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialInputComponent_mat_hint_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-hint", 15);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r3.model.hint, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialInputComponent_mat_hint_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-hint", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.characterHint);
} }
function DynamicMaterialInputComponent_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r8);
} }
function DynamicMaterialInputComponent_mat_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", option_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r9);
} }
const _c5 = ["matRadioGroup"];
function DynamicMaterialRadioGroupComponent_mat_radio_button_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-radio-button", 4);
    ɵngcc0.ɵɵelement(1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("name", ctx_r1.model.name)("ngClass", ctx_r1.getClass("element", "option"))("value", option_r2.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", option_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c6 = ["matSelect"];
function DynamicMaterialSelectComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 9);
    ɵngcc0.ɵɵelement(1, "mat-label", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.model.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialSelectComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.model.prefix, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialSelectComponent_mat_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 12);
    ɵngcc0.ɵɵelement(1, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", option_r7.disabled)("ngClass", ctx_r3.getClass("element", "option"))("value", option_r7.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", option_r7.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialSelectComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r4.model.suffix, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialSelectComponent_mat_hint_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-hint", 14);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r5.model.hint, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialSelectComponent_mat_error_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r8);
} }
const _c7 = ["matSlideToggle"];
function DynamicMaterialSlideToggleComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.model.offLabel, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialSlideToggleComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.model.onLabel, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c8 = ["matSlider"];
function DynamicMaterialTextAreaComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 6);
    ɵngcc0.ɵɵelement(1, "mat-label", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.model.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialTextAreaComponent_mat_hint_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-hint", 8);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.model.hint, ɵngcc0.ɵɵsanitizeHtml);
} }
function DynamicMaterialTextAreaComponent_mat_hint_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-hint", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.characterHint);
} }
function DynamicMaterialTextAreaComponent_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r4);
} }
const _c9 = ["componentViewContainer"];
function DynamicMaterialFormControlContainerComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("for", ctx_r0.id)("innerHTML", ctx_r0.model.label, ɵngcc0.ɵɵsanitizeHtml)("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c1, ctx_r0.getClass("element", "label"), ctx_r0.getClass("grid", "label")));
} }
function DynamicMaterialFormControlContainerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicMaterialFormControlContainerComponent_ng_container_5_mat_error_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r6);
} }
function DynamicMaterialFormControlContainerComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DynamicMaterialFormControlContainerComponent_ng_container_5_mat_error_1_Template, 2, 1, "mat-error", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.errorMessages);
} }
function DynamicMaterialFormControlContainerComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c10 = function (a0, a1, a2) { return [a0, a1, a2]; };
const _c11 = ["*"];
function DynamicMaterialFormArrayComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicMaterialFormArrayComponent_div_2_dynamic_material_form_control_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dynamic-material-form-control", 6);
    ɵngcc0.ɵɵlistener("blur", function DynamicMaterialFormArrayComponent_div_2_dynamic_material_form_control_2_Template_dynamic_material_form_control_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onBlur($event); })("change", function DynamicMaterialFormArrayComponent_div_2_dynamic_material_form_control_2_Template_dynamic_material_form_control_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onChange($event); })("focus", function DynamicMaterialFormArrayComponent_div_2_dynamic_material_form_control_2_Template_dynamic_material_form_control_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onFocus($event); })("matEvent", function DynamicMaterialFormArrayComponent_div_2_dynamic_material_form_control_2_Template_dynamic_material_form_control_matEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onCustomEvent($event, null, true); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _model_r6 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    const groupModel_r1 = ctx_r12.$implicit;
    const idx_r2 = ctx_r12.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("context", groupModel_r1)("group", ctx_r4.array.at(idx_r2))("hidden", _model_r6.hidden)("layout", ctx_r4.formLayout)("model", _model_r6)("templates", ctx_r4.templates)("hostClass", ɵngcc0.ɵɵpureFunction2(7, _c1, ctx_r4.getClass("element", "children"), ctx_r4.getClass("grid", "children")));
} }
function DynamicMaterialFormArrayComponent_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicMaterialFormArrayComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, DynamicMaterialFormArrayComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(2, DynamicMaterialFormArrayComponent_div_2_dynamic_material_form_control_2_Template, 1, 10, "dynamic-material-form-control", 5);
    ɵngcc0.ɵɵtemplate(3, DynamicMaterialFormArrayComponent_div_2_ng_container_3_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const groupModel_r1 = ctx.$implicit;
    const idx_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroupName", idx_r2)("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c1, ctx_r0.getClass("element", "group"), ctx_r0.getClass("grid", "group")));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.startTemplate == null ? null : ctx_r0.startTemplate.templateRef)("ngTemplateOutletContext", groupModel_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", groupModel_r1.group);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.endTemplate == null ? null : ctx_r0.endTemplate.templateRef)("ngTemplateOutletContext", groupModel_r1);
} }
function DynamicMaterialFormGroupComponent_dynamic_material_form_control_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dynamic-material-form-control", 3);
    ɵngcc0.ɵɵlistener("blur", function DynamicMaterialFormGroupComponent_dynamic_material_form_control_2_Template_dynamic_material_form_control_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onBlur($event); })("change", function DynamicMaterialFormGroupComponent_dynamic_material_form_control_2_Template_dynamic_material_form_control_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onChange($event); })("focus", function DynamicMaterialFormGroupComponent_dynamic_material_form_control_2_Template_dynamic_material_form_control_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onFocus($event); })("matEvent", function DynamicMaterialFormGroupComponent_dynamic_material_form_control_2_Template_dynamic_material_form_control_matEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onCustomEvent($event, null, true); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _model_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("group", ctx_r0.control)("hidden", _model_r1.hidden)("layout", ctx_r0.formLayout)("model", _model_r1)("templates", ctx_r0.templates)("hostClass", ɵngcc0.ɵɵpureFunction2(6, _c1, ctx_r0.getClass("element", "children"), ctx_r0.getClass("grid", "children")));
} }
function DynamicMaterialFormComponent_dynamic_material_form_control_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dynamic-material-form-control", 1);
    ɵngcc0.ɵɵlistener("blur", function DynamicMaterialFormComponent_dynamic_material_form_control_0_Template_dynamic_material_form_control_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onBlur($event); })("change", function DynamicMaterialFormComponent_dynamic_material_form_control_0_Template_dynamic_material_form_control_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onChange($event); })("focus", function DynamicMaterialFormComponent_dynamic_material_form_control_0_Template_dynamic_material_form_control_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onFocus($event); })("matEvent", function DynamicMaterialFormComponent_dynamic_material_form_control_0_Template_dynamic_material_form_control_matEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onCustomEvent($event, ctx_r6.matEvent); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const controlModel_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("group", ctx_r0.group)("hidden", controlModel_r1.hidden)("layout", ctx_r0.layout)("model", controlModel_r1)("templates", ctx_r0.templates);
} }
class DynamicMaterialFormInputControlComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
    }
    get characterCount() {
        return this.matInput ? this.matInput.value.length : null;
    }
    get characterHint() {
        return `${this.characterCount} / ${this.model.maxLength}`;
    }
    get showCharacterHint() {
        return !!(this.model.maxLength && this.characterCount);
    }
}

class DynamicMaterialCheckboxComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService, RIPPLE_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.RIPPLE_OPTIONS = RIPPLE_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialCheckboxComponent.ɵfac = function DynamicMaterialCheckboxComponent_Factory(t) { return new (t || DynamicMaterialCheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(MAT_RIPPLE_GLOBAL_OPTIONS, 8)); };
DynamicMaterialCheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialCheckboxComponent, selectors: [["dynamic-material-checkbox"]], viewQuery: function DynamicMaterialCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matCheckbox = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 15, consts: [[3, "formGroup"], [3, "checked", "color", "disableRipple", "formControlName", "id", "indeterminate", "labelPosition", "name", "ngClass", "blur", "change", "focus", "indeterminateChange"], ["matCheckbox", ""], [3, "ngClass", "innerHTML"]], template: function DynamicMaterialCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "mat-checkbox", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function DynamicMaterialCheckboxComponent_Template_mat_checkbox_blur_1_listener($event) { return ctx.onBlur($event); })("change", function DynamicMaterialCheckboxComponent_Template_mat_checkbox_change_1_listener($event) { return ctx.onChange($event); })("focus", function DynamicMaterialCheckboxComponent_Template_mat_checkbox_focus_1_listener($event) { return ctx.onFocus($event); })("indeterminateChange", function DynamicMaterialCheckboxComponent_Template_mat_checkbox_indeterminateChange_1_listener($event) { return ctx.onCustomEvent($event, "indeterminateChange"); });
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("checked", ctx.model.checked)("color", ctx.model.getAdditional("color", "accent"))("disableRipple", ctx.model.getAdditional("disableRipple", ctx.RIPPLE_OPTIONS && ctx.RIPPLE_OPTIONS["disabled"] || false))("formControlName", ctx.model.id)("id", ctx.id)("indeterminate", ctx.model.indeterminate)("labelPosition", ctx.model.labelPosition || "after")("name", ctx.model.name)("ngClass", ɵngcc0.ɵɵpureFunction2(12, _c1, ctx.getClass("element", "control"), ctx.getClass("grid", "control")));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getClass("element", "label"))("innerHTML", ctx.model.label, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.MatCheckbox, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc4.NgClass], encapsulation: 2 });
DynamicMaterialCheckboxComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialCheckboxComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matCheckbox: [{ type: ViewChild, args: ["matCheckbox", { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialCheckboxComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-checkbox",
                template: "<ng-container [formGroup]=\"group\">\n\n    <mat-checkbox #matCheckbox\n                  [checked]=\"model.checked\"\n                  [color]=\"model.getAdditional('color', 'accent')\"\n                  [disableRipple]=\"model.getAdditional('disableRipple', RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled'] || false)\"\n                  [formControlName]=\"model.id\"\n                  [id]=\"id\"\n                  [indeterminate]=\"model.indeterminate\"\n                  [labelPosition]=\"model.labelPosition || 'after'\"\n                  [name]=\"model.name\"\n                  [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\n                  (blur)=\"onBlur($event)\"\n                  (change)=\"onChange($event)\"\n                  (focus)=\"onFocus($event)\"\n                  (indeterminateChange)=\"onCustomEvent($event, 'indeterminateChange')\">\n\n        <span [ngClass]=\"getClass('element', 'label')\" [innerHTML]=\"model.label\"></span>\n\n    </mat-checkbox>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_RIPPLE_GLOBAL_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matCheckbox: [{
            type: ViewChild,
            args: ["matCheckbox", { static: true }]
        }] }); })();

class DynamicMaterialChipsComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService, AUTOCOMPLETE_OPTIONS, CHIPS_OPTIONS, FORM_FIELD_OPTIONS, RIPPLE_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.AUTOCOMPLETE_OPTIONS = AUTOCOMPLETE_OPTIONS;
        this.CHIPS_OPTIONS = CHIPS_OPTIONS;
        this.FORM_FIELD_OPTIONS = FORM_FIELD_OPTIONS;
        this.RIPPLE_OPTIONS = RIPPLE_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
    get chips() {
        return Array.isArray(this.model.value) ? this.model.value : [];
    }
    onChipInputTokenEnd($event) {
        var _a;
        const inputElement = (_a = $event.chipInput) === null || _a === void 0 ? void 0 : _a.inputElement;
        const inputValue = $event.value.trim();
        if (inputValue.length > 0) {
            this.control.patchValue([...this.chips, inputValue]);
            this.onChange($event);
        }
        if (inputElement instanceof HTMLInputElement) {
            inputElement.value = "";
        }
    }
    onChipSelected($event) {
        const selectedChip = $event.option.value;
        const chips = this.chips;
        if (!chips.includes(selectedChip)) {
            this.control.patchValue([...this.chips, selectedChip]);
        }
    }
    onChipRemoved(chip, index) {
        const chips = this.chips;
        if (chips[index] === chip) {
            chips.splice(index, 1);
            this.control.patchValue([...chips]);
        }
    }
}
DynamicMaterialChipsComponent.ɵfac = function DynamicMaterialChipsComponent_Factory(t) { return new (t || DynamicMaterialChipsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(MAT_AUTOCOMPLETE_DEFAULT_OPTIONS), ɵngcc0.ɵɵdirectiveInject(MAT_CHIPS_DEFAULT_OPTIONS), ɵngcc0.ɵɵdirectiveInject(MAT_FORM_FIELD_DEFAULT_OPTIONS, 8), ɵngcc0.ɵɵdirectiveInject(MAT_RIPPLE_GLOBAL_OPTIONS, 8)); };
DynamicMaterialChipsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialChipsComponent, selectors: [["dynamic-material-chips"]], viewQuery: function DynamicMaterialChipsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
        ɵngcc0.ɵɵviewQuery(_c3, 7);
        ɵngcc0.ɵɵviewQuery(MatInput, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matAutocomplete = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matChipList = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matInput = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 21, consts: [[3, "appearance", "color", "floatLabel", "formGroup", "hideRequiredMarker", "ngClass"], [3, "formControlName", "id", "multiple"], ["matChipList", ""], [3, "selectable", "removed", 4, "ngFor", "ngForOf"], ["matInput", "", 3, "matAutocomplete", "matChipInputAddOnBlur", "matChipInputFor", "matChipInputSeparatorKeyCodes", "placeholder", "matChipInputTokenEnd", "blur", "focus"], [3, "autoActiveFirstOption", "disableRipple", "displayWith", "optionSelected"], ["matAutocomplete", "matAutocomplete"], [3, "value", 4, "ngFor", "ngForOf"], [3, "selectable", "removed"], ["matChipRemove", ""], [3, "value"]], template: function DynamicMaterialChipsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-chip-list", 1, 2);
        ɵngcc0.ɵɵtemplate(3, DynamicMaterialChipsComponent_mat_chip_3_Template, 5, 2, "mat-chip", 3);
        ɵngcc0.ɵɵelementStart(4, "input", 4);
        ɵngcc0.ɵɵlistener("matChipInputTokenEnd", function DynamicMaterialChipsComponent_Template_input_matChipInputTokenEnd_4_listener($event) { return ctx.onChipInputTokenEnd($event); })("blur", function DynamicMaterialChipsComponent_Template_input_blur_4_listener($event) { return ctx.onBlur($event); })("focus", function DynamicMaterialChipsComponent_Template_input_focus_4_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "mat-autocomplete", 5, 6);
        ɵngcc0.ɵɵlistener("optionSelected", function DynamicMaterialChipsComponent_Template_mat_autocomplete_optionSelected_5_listener($event) { return ctx.onChipSelected($event); });
        ɵngcc0.ɵɵtemplate(7, DynamicMaterialChipsComponent_mat_option_7_Template, 2, 2, "mat-option", 7);
        ɵngcc0.ɵɵpipe(8, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        const _r2 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵproperty("appearance", ctx.model.getAdditional("appearance", "legacy"))("color", ctx.model.getAdditional("color", "primary"))("floatLabel", ctx.model.getAdditional("floatLabel", ctx.FORM_FIELD_OPTIONS && ctx.FORM_FIELD_OPTIONS["floatLabel"] || "auto"))("formGroup", ctx.group)("hideRequiredMarker", ctx.model.getAdditional("hideRequiredMarker", false))("ngClass", ctx.getClass("grid", "control"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.model.id)("id", ctx.id)("multiple", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.chips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matAutocomplete", _r2)("matChipInputAddOnBlur", ctx.model.getAdditional("matChipInputAddOnBlur", true))("matChipInputFor", _r0)("matChipInputSeparatorKeyCodes", ctx.model.getAdditional("matChipInputSeparatorKeyCodes", ctx.CHIPS_OPTIONS["separatorKeyCodes"]))("placeholder", ctx.model.placeholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("autoActiveFirstOption", ctx.model.getAdditional("autoActiveFirstOption", ctx.AUTOCOMPLETE_OPTIONS["autoActiveFirstOption"]))("disableRipple", ctx.model.getAdditional("disableRipple", ctx.RIPPLE_OPTIONS && ctx.RIPPLE_OPTIONS["disabled"] || false))("displayWith", ctx.model.getAdditional("displayWith", null));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(8, 19, ctx.model.list$));
    } }, directives: [ɵngcc5.MatFormField, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc4.NgClass, ɵngcc6.MatChipList, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc4.NgForOf, ɵngcc7.MatInput, ɵngcc8.MatAutocompleteTrigger, ɵngcc6.MatChipInput, ɵngcc8.MatAutocomplete, ɵngcc6.MatChip, ɵngcc9.MatIcon, ɵngcc6.MatChipRemove, ɵngcc10.MatOption], pipes: [ɵngcc4.AsyncPipe], encapsulation: 2 });
DynamicMaterialChipsComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_CHIPS_DEFAULT_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }, { type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialChipsComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matAutocomplete: [{ type: ViewChild, args: ["matAutocomplete", { static: true },] }],
    matChipList: [{ type: ViewChild, args: ["matChipList", { static: true },] }],
    matInput: [{ type: ViewChild, args: [MatInput, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialChipsComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-chips",
                template: "<mat-form-field [appearance]=\"model.getAdditional('appearance', 'legacy')\"\n                [color]=\"model.getAdditional('color', 'primary')\"\n                [floatLabel]=\"model.getAdditional('floatLabel', FORM_FIELD_OPTIONS && FORM_FIELD_OPTIONS['floatLabel'] || 'auto')\"\n                [formGroup]=\"group\"\n                [hideRequiredMarker]=\"model.getAdditional('hideRequiredMarker', false)\"\n                [ngClass]=\"getClass('grid', 'control')\">\n\n    <mat-chip-list #matChipList [formControlName]=\"model.id\" [id]=\"id\" [multiple]=\"true\">\n\n        <mat-chip *ngFor=\"let chip of chips; let index = index\"\n                  [selectable]=\"false\"\n                  (removed)=\"onChipRemoved(chip, index)\">\n\n            <span>{{ chip }}</span>\n\n            <mat-icon matChipRemove>cancel</mat-icon>\n\n        </mat-chip>\n\n        <input matInput\n               [matAutocomplete]=\"matAutocomplete\"\n               [matChipInputAddOnBlur]=\"model.getAdditional('matChipInputAddOnBlur', true)\"\n               [matChipInputFor]=\"matChipList\"\n               [matChipInputSeparatorKeyCodes]=\"model.getAdditional('matChipInputSeparatorKeyCodes', CHIPS_OPTIONS['separatorKeyCodes'])\"\n               [placeholder]=\"model.placeholder\"\n               (matChipInputTokenEnd)=\"onChipInputTokenEnd($event)\"\n               (blur)=\"onBlur($event)\"\n               (focus)=\"onFocus($event)\"/>\n\n        <mat-autocomplete #matAutocomplete=\"matAutocomplete\"\n                          [autoActiveFirstOption]=\"model.getAdditional('autoActiveFirstOption', AUTOCOMPLETE_OPTIONS['autoActiveFirstOption'])\"\n                          [disableRipple]=\"model.getAdditional('disableRipple', RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled'] || false)\"\n                          [displayWith]=\"model.getAdditional('displayWith', null)\"\n                          (optionSelected)=\"onChipSelected($event)\">\n\n            <mat-option *ngFor=\"let option of model.list$ | async\" [value]=\"option\">{{ option }}</mat-option>\n\n        </mat-autocomplete>\n\n    </mat-chip-list>\n\n</mat-form-field>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_CHIPS_DEFAULT_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_FORM_FIELD_DEFAULT_OPTIONS]
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_RIPPLE_GLOBAL_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matAutocomplete: [{
            type: ViewChild,
            args: ["matAutocomplete", { static: true }]
        }], matChipList: [{
            type: ViewChild,
            args: ["matChipList", { static: true }]
        }], matInput: [{
            type: ViewChild,
            args: [MatInput, { static: true }]
        }] }); })();

class DynamicMaterialDatePickerComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService, FORM_FIELD_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.FORM_FIELD_OPTIONS = FORM_FIELD_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialDatePickerComponent.ɵfac = function DynamicMaterialDatePickerComponent_Factory(t) { return new (t || DynamicMaterialDatePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(MAT_FORM_FIELD_DEFAULT_OPTIONS, 8)); };
DynamicMaterialDatePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialDatePickerComponent, selectors: [["dynamic-material-datepicker"]], viewQuery: function DynamicMaterialDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c4, 7);
        ɵngcc0.ɵɵviewQuery(MatInput, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matDatePicker = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matInput = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 27, consts: [[3, "appearance", "color", "floatLabel", "formGroup", "hideRequiredMarker", "ngClass"], ["ngProjectAs", "mat-label", 5, ["mat-label"], 4, "ngIf"], ["matPrefix", "", 3, "innerHTML", 4, "ngIf"], ["matInput", "", 3, "autofocus", "formControlName", "id", "max", "matDatepicker", "min", "name", "ngClass", "placeholder", "readonly", "required", "blur", "dateChange", "dateInput", "focus"], ["matSuffix", "", 3, "innerHTML", 4, "ngIf"], ["align", "start", 3, "innerHTML", 4, "ngIf"], ["matSuffix", "", 3, "for"], [3, "opened", "startAt", "startView", "touchUi", "closed", "monthSelected", "yearSelected"], ["matDatepicker", ""], [4, "ngFor", "ngForOf"], ["ngProjectAs", "mat-label", 5, ["mat-label"]], [3, "innerHTML"], ["matPrefix", "", 3, "innerHTML"], ["matSuffix", "", 3, "innerHTML"], ["align", "start", 3, "innerHTML"]], template: function DynamicMaterialDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵtemplate(1, DynamicMaterialDatePickerComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicMaterialDatePickerComponent_span_2_Template, 1, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "input", 3);
        ɵngcc0.ɵɵlistener("blur", function DynamicMaterialDatePickerComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("dateChange", function DynamicMaterialDatePickerComponent_Template_input_dateChange_3_listener($event) { return ctx.onChange($event); })("dateInput", function DynamicMaterialDatePickerComponent_Template_input_dateInput_3_listener($event) { return ctx.onCustomEvent($event, "dateInput"); })("focus", function DynamicMaterialDatePickerComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DynamicMaterialDatePickerComponent_span_4_Template, 1, 1, "span", 4);
        ɵngcc0.ɵɵtemplate(5, DynamicMaterialDatePickerComponent_mat_hint_5_Template, 1, 1, "mat-hint", 5);
        ɵngcc0.ɵɵelement(6, "mat-datepicker-toggle", 6);
        ɵngcc0.ɵɵelementStart(7, "mat-datepicker", 7, 8);
        ɵngcc0.ɵɵlistener("closed", function DynamicMaterialDatePickerComponent_Template_mat_datepicker_closed_7_listener($event) { return ctx.onCustomEvent($event, "closed"); })("monthSelected", function DynamicMaterialDatePickerComponent_Template_mat_datepicker_monthSelected_7_listener($event) { return ctx.onCustomEvent($event, "monthSelected"); })("opened", function DynamicMaterialDatePickerComponent_Template_mat_datepicker_opened_7_listener($event) { return ctx.onCustomEvent($event, "opened"); })("yearSelected", function DynamicMaterialDatePickerComponent_Template_mat_datepicker_yearSelected_7_listener($event) { return ctx.onCustomEvent($event, "yearSelected"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DynamicMaterialDatePickerComponent_mat_error_9_Template, 2, 1, "mat-error", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = ɵngcc0.ɵɵreference(8);
        ɵngcc0.ɵɵproperty("appearance", ctx.model.getAdditional("appearance", "legacy"))("color", ctx.model.getAdditional("color", "primary"))("floatLabel", ctx.model.getAdditional("floatLabel", ctx.FORM_FIELD_OPTIONS && ctx.FORM_FIELD_OPTIONS["floatLabel"] || "auto"))("formGroup", ctx.group)("hideRequiredMarker", ctx.model.getAdditional("hideRequiredMarker", false))("ngClass", ctx.getClass("grid", "control"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.prefix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("autofocus", ctx.model.autoFocus)("formControlName", ctx.model.id)("id", ctx.id)("max", ctx.model.max)("matDatepicker", _r4)("min", ctx.model.min)("name", ctx.model.name)("ngClass", ctx.getClass("element", "control"))("placeholder", ctx.model.placeholder)("readonly", ctx.model.readOnly)("required", ctx.model.required);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.suffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.hint !== null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("for", _r4);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("opened", ctx.model.getAdditional("opened", false))("startAt", ctx.model.focusedDate)("startView", ctx.model.getAdditional("startView", "month"))("touchUi", ctx.model.getAdditional("touchUi", false));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.errorMessages);
    } }, directives: [ɵngcc5.MatFormField, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc7.MatInput, ɵngcc2.DefaultValueAccessor, ɵngcc11.MatDatepickerInput, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.RequiredValidator, ɵngcc11.MatDatepickerToggle, ɵngcc5.MatSuffix, ɵngcc11.MatDatepicker, ɵngcc4.NgForOf, ɵngcc5.MatLabel, ɵngcc5.MatPrefix, ɵngcc5.MatHint, ɵngcc5.MatError], encapsulation: 2 });
DynamicMaterialDatePickerComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialDatePickerComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matDatePicker: [{ type: ViewChild, args: ["matDatepicker", { static: true },] }],
    matInput: [{ type: ViewChild, args: [MatInput, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialDatePickerComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-datepicker",
                template: "<mat-form-field [appearance]=\"model.getAdditional('appearance', 'legacy')\"\n                [color]=\"model.getAdditional('color', 'primary')\"\n                [floatLabel]=\"model.getAdditional('floatLabel', FORM_FIELD_OPTIONS && FORM_FIELD_OPTIONS['floatLabel'] || 'auto')\"\n                [formGroup]=\"group\"\n                [hideRequiredMarker]=\"model.getAdditional('hideRequiredMarker', false)\"\n                [ngClass]=\"getClass('grid', 'control')\">\n\n    <ng-container *ngIf=\"model.label\" ngProjectAs=\"mat-label\">\n\n        <mat-label [innerHTML]=\"model.label\"></mat-label>\n\n    </ng-container>\n\n    <span *ngIf=\"model.prefix\" matPrefix [innerHTML]=\"model.prefix\"></span>\n\n    <input matInput\n           [autofocus]=\"model.autoFocus\"\n           [formControlName]=\"model.id\"\n           [id]=\"id\"\n           [max]=\"model.max\"\n           [matDatepicker]=\"matDatepicker\"\n           [min]=\"model.min\"\n           [name]=\"model.name\"\n           [ngClass]=\"getClass('element', 'control')\"\n           [placeholder]=\"model.placeholder\"\n           [readonly]=\"model.readOnly\"\n           [required]=\"model.required\"\n           (blur)=\"onBlur($event)\"\n           (dateChange)=\"onChange($event)\"\n           (dateInput)=\"onCustomEvent($event, 'dateInput')\"\n           (focus)=\"onFocus($event)\"/>\n\n    <span *ngIf=\"model.suffix\" matSuffix [innerHTML]=\"model.suffix\"></span>\n\n    <mat-hint *ngIf=\"model.hint !== null\" align=\"start\" [innerHTML]=\"model.hint\"></mat-hint>\n\n\n    <mat-datepicker-toggle matSuffix [for]=\"matDatepicker\"></mat-datepicker-toggle>\n\n    <mat-datepicker #matDatepicker\n                    [opened]=\"model.getAdditional('opened', false)\"\n                    [startAt]=\"model.focusedDate\"\n                    [startView]=\"model.getAdditional('startView', 'month')\"\n                    [touchUi]=\"model.getAdditional('touchUi', false)\"\n                    (closed)=\"onCustomEvent($event, 'closed')\"\n                    (monthSelected)=\"onCustomEvent($event, 'monthSelected')\"\n                    (opened)=\"onCustomEvent($event, 'opened')\"\n                    (yearSelected)=\"onCustomEvent($event, 'yearSelected')\"></mat-datepicker>\n\n    <mat-error *ngFor=\"let message of errorMessages\">{{ message }}</mat-error>\n\n</mat-form-field>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_FORM_FIELD_DEFAULT_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matDatePicker: [{
            type: ViewChild,
            args: ["matDatepicker", { static: true }]
        }], matInput: [{
            type: ViewChild,
            args: [MatInput, { static: true }]
        }] }); })();

class DynamicMaterialInputComponent extends DynamicMaterialFormInputControlComponent {
    constructor(layoutService, validationService, errorStateMatcher, AUTOCOMPLETE_OPTIONS, FORM_FIELD_OPTIONS, RIPPLE_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.errorStateMatcher = errorStateMatcher;
        this.AUTOCOMPLETE_OPTIONS = AUTOCOMPLETE_OPTIONS;
        this.FORM_FIELD_OPTIONS = FORM_FIELD_OPTIONS;
        this.RIPPLE_OPTIONS = RIPPLE_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialInputComponent.ɵfac = function DynamicMaterialInputComponent_Factory(t) { return new (t || DynamicMaterialInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(ErrorStateMatcher), ɵngcc0.ɵɵdirectiveInject(MAT_AUTOCOMPLETE_DEFAULT_OPTIONS), ɵngcc0.ɵɵdirectiveInject(MAT_FORM_FIELD_DEFAULT_OPTIONS, 8), ɵngcc0.ɵɵdirectiveInject(MAT_RIPPLE_GLOBAL_OPTIONS, 8)); };
DynamicMaterialInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialInputComponent, selectors: [["dynamic-material-input"]], viewQuery: function DynamicMaterialInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
        ɵngcc0.ɵɵviewQuery(MatInput, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matAutocomplete = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matInput = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 40, consts: [[3, "appearance", "color", "floatLabel", "formGroup", "hideRequiredMarker", "ngClass"], ["ngProjectAs", "mat-label", 5, ["mat-label"], 4, "ngIf"], ["matPrefix", "", 3, "innerHTML", 4, "ngIf"], ["matInput", "", 3, "autocomplete", "autofocus", "errorStateMatcher", "formControlName", "id", "maxlength", "matAutocomplete", "minlength", "name", "ngClass", "pattern", "placeholder", "readonly", "required", "spellcheck", "tabindex", "type", "blur", "change", "focus"], ["matSuffix", "", 3, "innerHTML", 4, "ngIf"], ["align", "start", 3, "innerHTML", 4, "ngIf"], ["align", "end", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "autoActiveFirstOption", "disableRipple", "displayWith", "optionSelected"], ["matAutocomplete", "matAutocomplete"], [3, "value", 4, "ngFor", "ngForOf"], ["ngProjectAs", "mat-label", 5, ["mat-label"]], [3, "innerHTML"], ["matPrefix", "", 3, "innerHTML"], ["matSuffix", "", 3, "innerHTML"], ["align", "start", 3, "innerHTML"], ["align", "end"], [3, "value"]], template: function DynamicMaterialInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵtemplate(1, DynamicMaterialInputComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicMaterialInputComponent_span_2_Template, 1, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "input", 3);
        ɵngcc0.ɵɵlistener("blur", function DynamicMaterialInputComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("change", function DynamicMaterialInputComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("focus", function DynamicMaterialInputComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DynamicMaterialInputComponent_span_4_Template, 1, 1, "span", 4);
        ɵngcc0.ɵɵtemplate(5, DynamicMaterialInputComponent_mat_hint_5_Template, 1, 1, "mat-hint", 5);
        ɵngcc0.ɵɵtemplate(6, DynamicMaterialInputComponent_mat_hint_6_Template, 2, 1, "mat-hint", 6);
        ɵngcc0.ɵɵtemplate(7, DynamicMaterialInputComponent_mat_error_7_Template, 2, 1, "mat-error", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "mat-autocomplete", 8, 9);
        ɵngcc0.ɵɵlistener("optionSelected", function DynamicMaterialInputComponent_Template_mat_autocomplete_optionSelected_8_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵtemplate(10, DynamicMaterialInputComponent_mat_option_10_Template, 2, 2, "mat-option", 10);
        ɵngcc0.ɵɵpipe(11, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r6 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵproperty("appearance", ctx.model.getAdditional("appearance", "legacy"))("color", ctx.model.getAdditional("color", "primary"))("floatLabel", ctx.model.getAdditional("floatLabel", ctx.FORM_FIELD_OPTIONS && ctx.FORM_FIELD_OPTIONS["floatLabel"] || "auto"))("formGroup", ctx.group)("hideRequiredMarker", ctx.model.getAdditional("hideRequiredMarker", false))("ngClass", ctx.getClass("grid", "control"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.prefix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("autocomplete", ctx.model.autoComplete)("autofocus", ctx.model.autoFocus)("errorStateMatcher", ctx.model.getAdditional("errorStateMatcher", ctx.errorStateMatcher))("formControlName", ctx.model.id)("id", ctx.id)("maxlength", ctx.model.maxLength)("matAutocomplete", _r6)("minlength", ctx.model.minLength)("name", ctx.model.name)("ngClass", ctx.getClass("element", "control"))("pattern", ctx.model.pattern)("placeholder", ctx.model.placeholder)("readonly", ctx.model.readOnly)("required", ctx.model.required)("spellcheck", ctx.model.spellCheck)("tabindex", ctx.model.tabIndex)("type", ctx.model.inputType);
        ɵngcc0.ɵɵattribute("accept", ctx.model.accept)("max", ctx.model.max)("min", ctx.model.min)("multiple", ctx.model.multiple)("step", ctx.model.step);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.suffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.hint !== null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCharacterHint);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.errorMessages);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("autoActiveFirstOption", ctx.model.getAdditional("autoActiveFirstOption", ctx.AUTOCOMPLETE_OPTIONS["autoActiveFirstOption"]))("disableRipple", ctx.model.getAdditional("disableRipple", ctx.RIPPLE_OPTIONS && ctx.RIPPLE_OPTIONS["disabled"] || false))("displayWith", ctx.model.getAdditional("displayWith", null));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(11, 38, ctx.model.list$));
    } }, directives: [ɵngcc5.MatFormField, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc7.MatInput, ɵngcc2.DefaultValueAccessor, ɵngcc8.MatAutocompleteTrigger, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.MaxLengthValidator, ɵngcc2.MinLengthValidator, ɵngcc2.PatternValidator, ɵngcc2.RequiredValidator, ɵngcc4.NgForOf, ɵngcc8.MatAutocomplete, ɵngcc5.MatLabel, ɵngcc5.MatPrefix, ɵngcc5.MatSuffix, ɵngcc5.MatHint, ɵngcc5.MatError, ɵngcc10.MatOption], pipes: [ɵngcc4.AsyncPipe], encapsulation: 2 });
DynamicMaterialInputComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: ErrorStateMatcher, decorators: [{ type: Inject, args: [ErrorStateMatcher,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }, { type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialInputComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matAutocomplete: [{ type: ViewChild, args: ["matAutocomplete", { static: true },] }],
    matInput: [{ type: ViewChild, args: [MatInput, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialInputComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-input",
                template: "<mat-form-field [appearance]=\"model.getAdditional('appearance', 'legacy')\"\n                [color]=\"model.getAdditional('color', 'primary')\"\n                [floatLabel]=\"model.getAdditional('floatLabel', FORM_FIELD_OPTIONS && FORM_FIELD_OPTIONS['floatLabel'] || 'auto')\"\n                [formGroup]=\"group\"\n                [hideRequiredMarker]=\"model.getAdditional('hideRequiredMarker', false)\"\n                [ngClass]=\"getClass('grid','control')\">\n\n    <ng-container *ngIf=\"model.label\" ngProjectAs=\"mat-label\">\n\n        <mat-label [innerHTML]=\"model.label\"></mat-label>\n\n    </ng-container>\n\n    <span *ngIf=\"model.prefix\" matPrefix [innerHTML]=\"model.prefix\"></span>\n\n    <input matInput\n           [attr.accept]=\"model.accept\"\n           [attr.max]=\"model.max\"\n           [attr.min]=\"model.min\"\n           [attr.multiple]=\"model.multiple\"\n           [attr.step]=\"model.step\"\n           [autocomplete]=\"model.autoComplete\"\n           [autofocus]=\"model.autoFocus\"\n           [errorStateMatcher]=\"model.getAdditional('errorStateMatcher', errorStateMatcher)\"\n           [formControlName]=\"model.id\"\n           [id]=\"id\"\n           [maxlength]=\"model.maxLength\"\n           [matAutocomplete]=\"matAutocomplete\"\n           [minlength]=\"model.minLength\"\n           [name]=\"model.name\"\n           [ngClass]=\"getClass('element', 'control')\"\n           [pattern]=\"model.pattern\"\n           [placeholder]=\"model.placeholder\"\n           [readonly]=\"model.readOnly\"\n           [required]=\"model.required\"\n           [spellcheck]=\"model.spellCheck\"\n           [tabindex]=\"model.tabIndex\"\n           [type]=\"model.inputType\"\n           (blur)=\"onBlur($event)\"\n           (change)=\"onChange($event)\"\n           (focus)=\"onFocus($event)\"/>\n\n    <span *ngIf=\"model.suffix\" matSuffix [innerHTML]=\"model.suffix\"></span>\n\n    <mat-hint *ngIf=\"model.hint !== null\" align=\"start\" [innerHTML]=\"model.hint\"></mat-hint>\n\n    <mat-hint *ngIf=\"showCharacterHint\" align=\"end\">{{ characterHint }}</mat-hint>\n\n    <mat-error *ngFor=\"let message of errorMessages\">{{ message }}</mat-error>\n\n</mat-form-field>\n\n<mat-autocomplete #matAutocomplete=\"matAutocomplete\"\n                  [autoActiveFirstOption]=\"model.getAdditional('autoActiveFirstOption', AUTOCOMPLETE_OPTIONS['autoActiveFirstOption'])\"\n                  [disableRipple]=\"model.getAdditional('disableRipple', RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled'] || false)\"\n                  [displayWith]=\"model.getAdditional('displayWith', null)\"\n                  (optionSelected)=\"onChange($event)\">\n\n    <mat-option *ngFor=\"let option of model.list$ | async\" [value]=\"option\">{{ option }}</mat-option>\n\n</mat-autocomplete>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: ɵngcc10.ErrorStateMatcher, decorators: [{
                type: Inject,
                args: [ErrorStateMatcher]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_FORM_FIELD_DEFAULT_OPTIONS]
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_RIPPLE_GLOBAL_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matAutocomplete: [{
            type: ViewChild,
            args: ["matAutocomplete", { static: true }]
        }], matInput: [{
            type: ViewChild,
            args: [MatInput, { static: true }]
        }] }); })();

class DynamicMaterialRadioGroupComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialRadioGroupComponent.ɵfac = function DynamicMaterialRadioGroupComponent_Factory(t) { return new (t || DynamicMaterialRadioGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService)); };
DynamicMaterialRadioGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialRadioGroupComponent, selectors: [["dynamic-material-radio-group"]], viewQuery: function DynamicMaterialRadioGroupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matRadioGroup = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 13, consts: [[3, "formGroup"], [3, "formControlName", "id", "labelPosition", "name", "ngClass", "required", "blur", "change", "focus"], ["matRadioGroup", ""], [3, "name", "ngClass", "value", 4, "ngFor", "ngForOf"], [3, "name", "ngClass", "value"], [3, "innerHTML"]], template: function DynamicMaterialRadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "mat-radio-group", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function DynamicMaterialRadioGroupComponent_Template_mat_radio_group_blur_1_listener($event) { return ctx.onBlur($event); })("change", function DynamicMaterialRadioGroupComponent_Template_mat_radio_group_change_1_listener($event) { return ctx.onChange($event); })("focus", function DynamicMaterialRadioGroupComponent_Template_mat_radio_group_focus_1_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵtemplate(3, DynamicMaterialRadioGroupComponent_mat_radio_button_3_Template, 2, 4, "mat-radio-button", 3);
        ɵngcc0.ɵɵpipe(4, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.model.id)("id", ctx.id)("labelPosition", ctx.model.getAdditional("labelPosition", "after"))("name", ctx.model.name)("ngClass", ɵngcc0.ɵɵpureFunction2(10, _c1, ctx.getClass("element", "control"), ctx.getClass("grid", "control")))("required", ctx.model.required);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(4, 8, ctx.model.options$));
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc12.MatRadioGroup, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc4.NgClass, ɵngcc2.RequiredValidator, ɵngcc4.NgForOf, ɵngcc12.MatRadioButton], pipes: [ɵngcc4.AsyncPipe], encapsulation: 2 });
DynamicMaterialRadioGroupComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService }
];
DynamicMaterialRadioGroupComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matRadioGroup: [{ type: ViewChild, args: ["matRadioGroup", { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialRadioGroupComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-radio-group",
                template: "<ng-container [formGroup]=\"group\">\n\n    <mat-radio-group #matRadioGroup\n                     [formControlName]=\"model.id\"\n                     [id]=\"id\"\n                     [labelPosition]=\"model.getAdditional('labelPosition', 'after')\"\n                     [name]=\"model.name\"\n                     [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\n                     [required]=\"model.required\"\n                     (blur)=\"onBlur($event)\"\n                     (change)=\"onChange($event)\"\n                     (focus)=\"onFocus($event)\">\n\n        <mat-radio-button *ngFor=\"let option of model.options$ | async\"\n                          [name]=\"model.name\"\n                          [ngClass]=\"getClass('element', 'option')\"\n                          [value]=\"option.value\"><span [innerHTML]=\"option.label\"></span></mat-radio-button>\n\n    </mat-radio-group>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matRadioGroup: [{
            type: ViewChild,
            args: ["matRadioGroup", { static: true }]
        }] }); })();

class DynamicMaterialSelectComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService, errorStateMatcher, FORM_FIELD_OPTIONS, RIPPLE_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.errorStateMatcher = errorStateMatcher;
        this.FORM_FIELD_OPTIONS = FORM_FIELD_OPTIONS;
        this.RIPPLE_OPTIONS = RIPPLE_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialSelectComponent.ɵfac = function DynamicMaterialSelectComponent_Factory(t) { return new (t || DynamicMaterialSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(ErrorStateMatcher), ɵngcc0.ɵɵdirectiveInject(MAT_FORM_FIELD_DEFAULT_OPTIONS, 8), ɵngcc0.ɵɵdirectiveInject(MAT_RIPPLE_GLOBAL_OPTIONS, 8)); };
DynamicMaterialSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialSelectComponent, selectors: [["dynamic-material-select"]], viewQuery: function DynamicMaterialSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matSelect = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 23, consts: [[3, "appearance", "color", "ngClass", "floatLabel", "formGroup"], ["ngProjectAs", "mat-label", 5, ["mat-label"], 4, "ngIf"], ["matPrefix", "", 3, "innerHTML", 4, "ngIf"], [3, "compareWith", "disableOptionCentering", "disableRipple", "errorStateMatcher", "formControlName", "id", "multiple", "ngClass", "placeholder", "required", "openedChange", "selectionChange"], ["matSelect", ""], [3, "disabled", "ngClass", "value", 4, "ngFor", "ngForOf"], ["matSuffix", "", 3, "innerHTML", 4, "ngIf"], ["align", "start", 3, "innerHTML", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["ngProjectAs", "mat-label", 5, ["mat-label"]], [3, "innerHTML"], ["matPrefix", "", 3, "innerHTML"], [3, "disabled", "ngClass", "value"], ["matSuffix", "", 3, "innerHTML"], ["align", "start", 3, "innerHTML"]], template: function DynamicMaterialSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵtemplate(1, DynamicMaterialSelectComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicMaterialSelectComponent_span_2_Template, 1, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "mat-select", 3, 4);
        ɵngcc0.ɵɵlistener("openedChange", function DynamicMaterialSelectComponent_Template_mat_select_openedChange_3_listener($event) { return ctx.onCustomEvent($event, "openedChange"); })("selectionChange", function DynamicMaterialSelectComponent_Template_mat_select_selectionChange_3_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵtemplate(5, DynamicMaterialSelectComponent_mat_option_5_Template, 2, 4, "mat-option", 5);
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DynamicMaterialSelectComponent_span_7_Template, 1, 1, "span", 6);
        ɵngcc0.ɵɵtemplate(8, DynamicMaterialSelectComponent_mat_hint_8_Template, 1, 1, "mat-hint", 7);
        ɵngcc0.ɵɵtemplate(9, DynamicMaterialSelectComponent_mat_error_9_Template, 2, 1, "mat-error", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("appearance", ctx.model.getAdditional("appearance", "legacy"))("color", ctx.model.getAdditional("color", "primary"))("ngClass", ctx.getClass("grid", "control"))("floatLabel", ctx.model.getAdditional("floatLabel", ctx.FORM_FIELD_OPTIONS && ctx.FORM_FIELD_OPTIONS["floatLabel"] || "auto"))("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.prefix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("compareWith", ctx.model.compareWithFn)("disableOptionCentering", ctx.model.getAdditional("disableOptionCentering", false))("disableRipple", ctx.model.getAdditional("disableRipple", ctx.RIPPLE_OPTIONS && ctx.RIPPLE_OPTIONS["disabled"] || false))("errorStateMatcher", ctx.model.getAdditional("errorStateMatcher", ctx.errorStateMatcher))("formControlName", ctx.model.id)("id", ctx.id)("multiple", ctx.model.multiple)("ngClass", ctx.getClass("element", "control"))("placeholder", ctx.model.placeholder)("required", ctx.model.required);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(6, 21, ctx.model.options$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.suffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.hint !== null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.errorMessages);
    } }, directives: [ɵngcc5.MatFormField, ɵngcc4.NgClass, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc4.NgIf, ɵngcc13.MatSelect, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.RequiredValidator, ɵngcc4.NgForOf, ɵngcc5.MatLabel, ɵngcc5.MatPrefix, ɵngcc10.MatOption, ɵngcc5.MatSuffix, ɵngcc5.MatHint, ɵngcc5.MatError], pipes: [ɵngcc4.AsyncPipe], encapsulation: 2 });
DynamicMaterialSelectComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: ErrorStateMatcher, decorators: [{ type: Inject, args: [ErrorStateMatcher,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }, { type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialSelectComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matSelect: [{ type: ViewChild, args: ["matSelect", { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialSelectComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-select",
                template: "<mat-form-field [appearance]=\"model.getAdditional('appearance', 'legacy')\"\n                [color]=\"model.getAdditional('color', 'primary')\"\n                [ngClass]=\"getClass('grid', 'control')\"\n                [floatLabel]=\"model.getAdditional('floatLabel', FORM_FIELD_OPTIONS && FORM_FIELD_OPTIONS['floatLabel'] || 'auto')\"\n                [formGroup]=\"group\">\n\n    <ng-container *ngIf=\"model.label\" ngProjectAs=\"mat-label\">\n\n        <mat-label [innerHTML]=\"model.label\"></mat-label>\n\n    </ng-container>\n\n    <span *ngIf=\"model.prefix\" matPrefix [innerHTML]=\"model.prefix\"></span>\n\n    <mat-select #matSelect\n                [compareWith]=\"model.compareWithFn\"\n                [disableOptionCentering]=\"model.getAdditional('disableOptionCentering', false)\"\n                [disableRipple]=\"model.getAdditional('disableRipple', RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled'] || false)\"\n                [errorStateMatcher]=\"model.getAdditional('errorStateMatcher', errorStateMatcher)\"\n                [formControlName]=\"model.id\"\n                [id]=\"id\"\n                [multiple]=\"model.multiple\"\n                [ngClass]=\"getClass('element', 'control')\"\n                [placeholder]=\"model.placeholder\"\n                [required]=\"model.required\"\n                (openedChange)=\"onCustomEvent($event, 'openedChange')\"\n                (selectionChange)=\"onChange($event)\">\n\n        <mat-option *ngFor=\"let option of model.options$ | async\"\n                    [disabled]=\"option.disabled\"\n                    [ngClass]=\"getClass('element', 'option')\"\n                    [value]=\"option.value\"><span [innerHTML]=\"option.label\"></span></mat-option>\n    </mat-select>\n\n    <span *ngIf=\"model.suffix\" matSuffix [innerHTML]=\"model.suffix\"></span>\n\n    <mat-hint *ngIf=\"model.hint !== null\" align=\"start\" [innerHTML]=\"model.hint\"></mat-hint>\n\n    <mat-error *ngFor=\"let message of errorMessages\">{{ message }}</mat-error>\n\n</mat-form-field>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: ɵngcc10.ErrorStateMatcher, decorators: [{
                type: Inject,
                args: [ErrorStateMatcher]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_FORM_FIELD_DEFAULT_OPTIONS]
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_RIPPLE_GLOBAL_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matSelect: [{
            type: ViewChild,
            args: ["matSelect", { static: true }]
        }] }); })();

class DynamicMaterialSlideToggleComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService, RIPPLE_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.RIPPLE_OPTIONS = RIPPLE_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialSlideToggleComponent.ɵfac = function DynamicMaterialSlideToggleComponent_Factory(t) { return new (t || DynamicMaterialSlideToggleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(MAT_RIPPLE_GLOBAL_OPTIONS, 8)); };
DynamicMaterialSlideToggleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialSlideToggleComponent, selectors: [["dynamic-material-slide-toggle"]], viewQuery: function DynamicMaterialSlideToggleComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matSlideToggle = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 14, consts: [[3, "formGroup"], [3, "checked", "color", "disableRipple", "formControlName", "id", "labelPosition", "name", "ngClass", "change", "toggleChange"], ["matSlideToggle", ""], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function DynamicMaterialSlideToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "mat-slide-toggle", 1, 2);
        ɵngcc0.ɵɵlistener("change", function DynamicMaterialSlideToggleComponent_Template_mat_slide_toggle_change_1_listener($event) { return ctx.onChange($event); })("toggleChange", function DynamicMaterialSlideToggleComponent_Template_mat_slide_toggle_toggleChange_1_listener($event) { return ctx.onCustomEvent($event, "toggleChange"); });
        ɵngcc0.ɵɵtemplate(3, DynamicMaterialSlideToggleComponent_span_3_Template, 1, 1, "span", 3);
        ɵngcc0.ɵɵtemplate(4, DynamicMaterialSlideToggleComponent_span_4_Template, 1, 1, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("checked", ctx.model.checked)("color", ctx.model.getAdditional("color", "accent"))("disableRipple", ctx.model.getAdditional("disableRipple", ctx.RIPPLE_OPTIONS && ctx.RIPPLE_OPTIONS["disabled"] || false))("formControlName", ctx.model.id)("id", ctx.id)("labelPosition", ctx.model.labelPosition || "after")("name", ctx.model.name)("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c1, ctx.getClass("element", "control"), ctx.getClass("grid", "control")));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.model.checked);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.checked);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc14.MatSlideToggle, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc4.NgClass, ɵngcc4.NgIf], encapsulation: 2 });
DynamicMaterialSlideToggleComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialSlideToggleComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matSlideToggle: [{ type: ViewChild, args: ["matSlideToggle", { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialSlideToggleComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-slide-toggle",
                template: "<ng-container [formGroup]=\"group\">\n\n    <mat-slide-toggle #matSlideToggle\n                      [checked]=\"model.checked\"\n                      [color]=\"model.getAdditional('color', 'accent')\"\n                      [disableRipple]=\"model.getAdditional('disableRipple', RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled'] || false)\"\n                      [formControlName]=\"model.id\"\n                      [id]=\"id\"\n                      [labelPosition]=\"model.labelPosition || 'after'\"\n                      [name]=\"model.name\"\n                      [ngClass]=\"[getClass('element','control'), getClass('grid','control')]\"\n                      (change)=\"onChange($event)\"\n                      (toggleChange)=\"onCustomEvent($event, 'toggleChange')\">\n\n        <span *ngIf=\"!model.checked\" [innerHTML]=\"model.offLabel\"></span>\n\n        <span *ngIf=\"model.checked\" [innerHTML]=\"model.onLabel\"></span>\n\n    </mat-slide-toggle>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_RIPPLE_GLOBAL_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matSlideToggle: [{
            type: ViewChild,
            args: ["matSlideToggle", { static: true }]
        }] }); })();

class DynamicMaterialSliderComponent extends DynamicFormControlComponent {
    constructor(layoutService, validationService) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialSliderComponent.ɵfac = function DynamicMaterialSliderComponent_Factory(t) { return new (t || DynamicMaterialSliderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService)); };
DynamicMaterialSliderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialSliderComponent, selectors: [["dynamic-material-slider"]], viewQuery: function DynamicMaterialSliderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matSlider = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 16, consts: [[3, "formGroup"], [3, "color", "formControlName", "id", "invert", "min", "max", "ngClass", "step", "tabIndex", "thumbLabel", "tickInterval", "vertical", "change", "input"], ["matSlider", ""]], template: function DynamicMaterialSliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "mat-slider", 1, 2);
        ɵngcc0.ɵɵlistener("change", function DynamicMaterialSliderComponent_Template_mat_slider_change_1_listener($event) { return ctx.onChange($event); })("input", function DynamicMaterialSliderComponent_Template_mat_slider_input_1_listener($event) { return ctx.onCustomEvent($event, "input"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.model.getAdditional("color", "accent"))("formControlName", ctx.model.id)("id", ctx.id)("invert", ctx.model.getAdditional("invert", false))("min", ctx.model.min)("max", ctx.model.max)("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c1, ctx.getClass("element", "control"), ctx.getClass("grid", "control")))("step", ctx.model.step)("tabIndex", ctx.model.tabIndex)("thumbLabel", ctx.model.getAdditional("thumbLabel", true))("tickInterval", ctx.model.getAdditional("tickInterval", 1))("vertical", ctx.model.vertical);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc15.MatSlider, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc4.NgClass], encapsulation: 2 });
DynamicMaterialSliderComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService }
];
DynamicMaterialSliderComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matSlider: [{ type: ViewChild, args: ["matSlider", { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialSliderComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-slider",
                template: "<ng-container [formGroup]=\"group\">\n\n    <mat-slider #matSlider\n                [color]=\"model.getAdditional('color', 'accent')\"\n                [formControlName]=\"model.id\"\n                [id]=\"id\"\n                [invert]=\"model.getAdditional('invert', false)\"\n                [min]=\"model.min\"\n                [max]=\"model.max\"\n                [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\"\n                [step]=\"model.step\"\n                [tabIndex]=\"model.tabIndex\"\n                [thumbLabel]=\"model.getAdditional('thumbLabel', true)\"\n                [tickInterval]=\"model.getAdditional('tickInterval', 1)\"\n                [vertical]=\"model.vertical\"\n                (change)=\"onChange($event)\"\n                (input)=\"onCustomEvent($event, 'input')\"></mat-slider>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matSlider: [{
            type: ViewChild,
            args: ["matSlider", { static: true }]
        }] }); })();

class DynamicMaterialTextAreaComponent extends DynamicMaterialFormInputControlComponent {
    constructor(layoutService, validationService, FORM_FIELD_OPTIONS) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.FORM_FIELD_OPTIONS = FORM_FIELD_OPTIONS;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialTextAreaComponent.ɵfac = function DynamicMaterialTextAreaComponent_Factory(t) { return new (t || DynamicMaterialTextAreaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(MAT_FORM_FIELD_DEFAULT_OPTIONS, 8)); };
DynamicMaterialTextAreaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialTextAreaComponent, selectors: [["dynamic-material-textarea"]], viewQuery: function DynamicMaterialTextAreaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatInput, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matInput = _t.first);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 25, consts: [[3, "appearance", "color", "floatLabel", "formGroup", "hideRequiredMarker", "ngClass"], ["ngProjectAs", "mat-label", 5, ["mat-label"], 4, "ngIf"], ["matInput", "", 3, "cdkTextareaAutosize", "cols", "formControlName", "id", "maxlength", "minlength", "name", "ngClass", "placeholder", "readonly", "required", "rows", "spellcheck", "tabindex", "wrap", "blur", "change", "focus"], ["align", "start", 3, "innerHTML", 4, "ngIf"], ["align", "end", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["ngProjectAs", "mat-label", 5, ["mat-label"]], [3, "innerHTML"], ["align", "start", 3, "innerHTML"], ["align", "end"]], template: function DynamicMaterialTextAreaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵtemplate(1, DynamicMaterialTextAreaComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(2, "textarea", 2);
        ɵngcc0.ɵɵlistener("blur", function DynamicMaterialTextAreaComponent_Template_textarea_blur_2_listener($event) { return ctx.onBlur($event); })("change", function DynamicMaterialTextAreaComponent_Template_textarea_change_2_listener($event) { return ctx.onChange($event); })("focus", function DynamicMaterialTextAreaComponent_Template_textarea_focus_2_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DynamicMaterialTextAreaComponent_mat_hint_3_Template, 1, 1, "mat-hint", 3);
        ɵngcc0.ɵɵtemplate(4, DynamicMaterialTextAreaComponent_mat_hint_4_Template, 2, 1, "mat-hint", 4);
        ɵngcc0.ɵɵtemplate(5, DynamicMaterialTextAreaComponent_mat_error_5_Template, 2, 1, "mat-error", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("appearance", ctx.model.getAdditional("appearance", "legacy"))("color", ctx.model.getAdditional("color", "primary"))("floatLabel", ctx.model.getAdditional("floatLabel", ctx.FORM_FIELD_OPTIONS && ctx.FORM_FIELD_OPTIONS["floatLabel"] || "auto"))("formGroup", ctx.group)("hideRequiredMarker", ctx.model.getAdditional("hideRequiredMarker", false))("ngClass", ctx.getClass("grid", "control"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkTextareaAutosize", ctx.model.getAdditional("cdkTextareaAutosize", true))("cols", ctx.model.cols)("formControlName", ctx.model.id)("id", ctx.id)("maxlength", ctx.model.maxLength)("minlength", ctx.model.minLength)("name", ctx.model.name)("ngClass", ctx.getClass("element", "control"))("placeholder", ctx.model.placeholder)("readonly", ctx.model.readOnly)("required", ctx.model.required)("rows", ctx.model.rows)("spellcheck", ctx.model.spellCheck)("tabindex", ctx.model.tabIndex)("wrap", ctx.model.wrap);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.model.hint !== null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCharacterHint);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.errorMessages);
    } }, directives: [ɵngcc5.MatFormField, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc7.MatInput, ɵngcc16.CdkTextareaAutosize, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.MaxLengthValidator, ɵngcc2.MinLengthValidator, ɵngcc2.RequiredValidator, ɵngcc4.NgForOf, ɵngcc5.MatLabel, ɵngcc5.MatHint, ɵngcc5.MatError], encapsulation: 2 });
DynamicMaterialTextAreaComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }, { type: Optional }] }
];
DynamicMaterialTextAreaComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    matInput: [{ type: ViewChild, args: [MatInput, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialTextAreaComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-textarea",
                template: "<mat-form-field [appearance]=\"model.getAdditional('appearance', 'legacy')\"\n                [color]=\"model.getAdditional('color', 'primary')\"\n                [floatLabel]=\"model.getAdditional('floatLabel', FORM_FIELD_OPTIONS && FORM_FIELD_OPTIONS['floatLabel'] || 'auto')\"\n                [formGroup]=\"group\"\n                [hideRequiredMarker]=\"model.getAdditional('hideRequiredMarker', false)\"\n                [ngClass]=\"getClass('grid', 'control')\">\n\n    <ng-container *ngIf=\"model.label\" ngProjectAs=\"mat-label\">\n\n        <mat-label [innerHTML]=\"model.label\"></mat-label>\n\n    </ng-container>\n\n    <textarea matInput\n              [cdkTextareaAutosize]=\"model.getAdditional('cdkTextareaAutosize', true)\"\n              [cols]=\"model.cols\"\n              [formControlName]=\"model.id\"\n              [id]=\"id\"\n              [maxlength]=\"model.maxLength\"\n              [minlength]=\"model.minLength\"\n              [name]=\"model.name\"\n              [ngClass]=\"getClass('element', 'control')\"\n              [placeholder]=\"model.placeholder\"\n              [readonly]=\"model.readOnly\"\n              [required]=\"model.required\"\n              [rows]=\"model.rows\"\n              [spellcheck]=\"model.spellCheck\"\n              [tabindex]=\"model.tabIndex\"\n              [wrap]=\"model.wrap\"\n              (blur)=\"onBlur($event)\"\n              (change)=\"onChange($event)\"\n              (focus)=\"onFocus($event)\"></textarea>\n\n    <mat-hint *ngIf=\"model.hint !== null\" align=\"start\" [innerHTML]=\"model.hint\"></mat-hint>\n\n    <mat-hint *ngIf=\"showCharacterHint\" align=\"end\">{{ characterHint }}</mat-hint>\n\n    <mat-error *ngFor=\"let message of errorMessages\">{{ message }}</mat-error>\n\n</mat-form-field>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_FORM_FIELD_DEFAULT_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], matInput: [{
            type: ViewChild,
            args: [MatInput, { static: true }]
        }] }); })();

class DynamicMaterialFormControlContainerComponent extends DynamicFormControlContainerComponent {
    constructor(changeDetectorRef, componentFactoryResolver, layoutService, validationService, componentService, relationService) {
        super(changeDetectorRef, componentFactoryResolver, layoutService, validationService, componentService, relationService);
        this.changeDetectorRef = changeDetectorRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.componentService = componentService;
        this.relationService = relationService;
        this.context = null;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.focus = new EventEmitter();
        // tslint:disable-next-line:no-output-rename
        this.customEvent = new EventEmitter();
    }
    get componentType() {
        return this.componentService.getCustomComponentType(this.model) || materialUIFormControlMapFn(this.model);
    }
    get hasMatFormField() {
        const matFormFieldTypes = [DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER, DYNAMIC_FORM_CONTROL_TYPE_INPUT,
            DYNAMIC_FORM_CONTROL_TYPE_SELECT, DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA];
        return matFormFieldTypes.some(type => this.model.type === type) || (this.model instanceof DynamicFormValueControlModel &&
            this.model.getAdditional("isFormFieldControl"));
    }
}
DynamicMaterialFormControlContainerComponent.ɵfac = function DynamicMaterialFormControlContainerComponent_Factory(t) { return new (t || DynamicMaterialFormControlContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormComponentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormRelationService)); };
DynamicMaterialFormControlContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialFormControlContainerComponent, selectors: [["dynamic-material-form-control"]], contentQueries: function DynamicMaterialFormControlContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DynamicTemplateDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentTemplateList = _t);
    } }, viewQuery: function DynamicMaterialFormControlContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.componentViewContainerRef = _t.first);
    } }, hostVars: 2, hostBindings: function DynamicMaterialFormControlContainerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.klass);
    } }, inputs: { context: "context", group: "group", hostClass: "hostClass", inputTemplateList: ["templates", "inputTemplateList"], layout: "layout", model: "model" }, outputs: { blur: "blur", change: "change", focus: "focus", customEvent: "matEvent" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c11, decls: 8, vars: 12, consts: [[3, "formGroup", "ngClass"], [3, "for", "innerHTML", "ngClass", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["componentViewContainer", ""], [4, "ngIf"], [3, "for", "innerHTML", "ngClass"], [4, "ngFor", "ngForOf"]], template: function DynamicMaterialFormControlContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DynamicMaterialFormControlContainerComponent_label_1_Template, 1, 6, "label", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicMaterialFormControlContainerComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵelementContainer(3, null, 3);
        ɵngcc0.ɵɵtemplate(5, DynamicMaterialFormControlContainerComponent_ng_container_5_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(6, DynamicMaterialFormControlContainerComponent_ng_container_6_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group)("ngClass", ɵngcc0.ɵɵpureFunction3(8, _c10, "ng-dynamic-forms-" + ctx.model.type.toLowerCase(), ctx.getClass("element", "container"), ctx.getClass("grid", "container")));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasMatFormField && !ctx.isCheckbox && ctx.hasLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.startTemplate == null ? null : ctx.startTemplate.templateRef)("ngTemplateOutletContext", ctx.model);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasMatFormField);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.endTemplate == null ? null : ctx.endTemplate.templateRef)("ngTemplateOutletContext", ctx.model);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc4.NgTemplateOutlet, ɵngcc4.NgForOf, ɵngcc5.MatError], encapsulation: 2, changeDetection: 0 });
DynamicMaterialFormControlContainerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ComponentFactoryResolver },
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService },
    { type: DynamicFormComponentService },
    { type: DynamicFormRelationService }
];
DynamicMaterialFormControlContainerComponent.propDecorators = {
    contentTemplateList: [{ type: ContentChildren, args: [DynamicTemplateDirective,] }],
    klass: [{ type: HostBinding, args: ["class",] }],
    context: [{ type: Input }],
    group: [{ type: Input }],
    hostClass: [{ type: Input }],
    inputTemplateList: [{ type: Input, args: ["templates",] }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    customEvent: [{ type: Output, args: ["matEvent",] }],
    componentViewContainerRef: [{ type: ViewChild, args: ["componentViewContainer", { read: ViewContainerRef, static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialFormControlContainerComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-form-control",
                template: "<div [formGroup]=\"group\"\n     [ngClass]=\"['ng-dynamic-forms-'+model.type.toLowerCase(), getClass('element', 'container'), getClass('grid', 'container')]\">\n\n    <label *ngIf=\"!hasMatFormField && !isCheckbox && hasLabel\"\n           [for]=\"id\"\n           [innerHTML]=\"model.label\"\n           [ngClass]=\"[getClass('element', 'label'), getClass('grid', 'label')]\"></label>\n\n    <ng-container *ngTemplateOutlet=\"startTemplate?.templateRef; context: model\"></ng-container>\n\n    <ng-container #componentViewContainer></ng-container>\n\n    <ng-container *ngIf=\"!hasMatFormField\">\n\n        <mat-error *ngFor=\"let message of errorMessages\">{{ message }}</mat-error>\n\n    </ng-container>\n\n    <ng-container *ngTemplateOutlet=\"endTemplate?.templateRef; context: model\"></ng-container>\n\n    <ng-content></ng-content>\n\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }, { type: ɵngcc1.DynamicFormComponentService }, { type: ɵngcc1.DynamicFormRelationService }]; }, { context: [{
            type: Input
        }], blur: [{
            type: Output
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], customEvent: [{
            type: Output,
            args: ["matEvent"]
        }], contentTemplateList: [{
            type: ContentChildren,
            args: [DynamicTemplateDirective]
        }], klass: [{
            type: HostBinding,
            args: ["class"]
        }], group: [{
            type: Input
        }], hostClass: [{
            type: Input
        }], inputTemplateList: [{
            type: Input,
            args: ["templates"]
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], componentViewContainerRef: [{
            type: ViewChild,
            args: ["componentViewContainer", { read: ViewContainerRef, static: true }]
        }] }); })();
function materialUIFormControlMapFn(model) {
    switch (model.type) {
        case DYNAMIC_FORM_CONTROL_TYPE_ARRAY:
            return DynamicMaterialFormArrayComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX:
            return DynamicMaterialCheckboxComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX_GROUP:
            return DynamicMaterialFormGroupComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER:
            return DynamicMaterialDatePickerComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_GROUP:
            return DynamicMaterialFormGroupComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_INPUT:
            const inputModel = model;
            return inputModel.multiple ? DynamicMaterialChipsComponent : DynamicMaterialInputComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_RADIO_GROUP:
            return DynamicMaterialRadioGroupComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_SELECT:
            return DynamicMaterialSelectComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_SLIDER:
            return DynamicMaterialSliderComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_SWITCH:
            return DynamicMaterialSlideToggleComponent;
        case DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA:
            return DynamicMaterialTextAreaComponent;
        default:
            return null;
    }
}
class DynamicMaterialFormArrayComponent extends DynamicFormArrayComponent {
    constructor(layoutService, validationService) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialFormArrayComponent.ɵfac = function DynamicMaterialFormArrayComponent_Factory(t) { return new (t || DynamicMaterialFormArrayComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService)); };
DynamicMaterialFormArrayComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialFormArrayComponent, selectors: [["dynamic-material-form-array"]], viewQuery: function DynamicMaterialFormArrayComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DynamicMaterialFormControlContainerComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.components = _t);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model", templates: "templates" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 5, consts: [[3, "formGroup"], [3, "formArrayName", "id", "ngClass"], ["role", "group", 3, "formGroupName", "ngClass", 4, "ngFor", "ngForOf"], ["role", "group", 3, "formGroupName", "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "context", "group", "hidden", "layout", "model", "templates", "hostClass", "blur", "change", "focus", "matEvent", 4, "ngFor", "ngForOf"], [3, "context", "group", "hidden", "layout", "model", "templates", "hostClass", "blur", "change", "focus", "matEvent"]], template: function DynamicMaterialFormArrayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicMaterialFormArrayComponent_div_2_Template, 4, 10, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formArrayName", ctx.model.id)("id", ctx.id)("ngClass", ctx.getClass("element", "control"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.model.groups);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.FormArrayName, ɵngcc4.NgClass, ɵngcc4.NgForOf, ɵngcc2.FormGroupName, ɵngcc4.NgTemplateOutlet, DynamicMaterialFormControlContainerComponent], encapsulation: 2 });
DynamicMaterialFormArrayComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService }
];
DynamicMaterialFormArrayComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    templates: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    components: [{ type: ViewChildren, args: [DynamicMaterialFormControlContainerComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialFormArrayComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-form-array",
                template: "<ng-container [formGroup]=\"group\">\n\n    <div [formArrayName]=\"model.id\" [id]=\"id\" [ngClass]=\"getClass('element', 'control')\">\n\n        <div *ngFor=\"let groupModel of model.groups; let idx = index\" role=\"group\"\n             [formGroupName]=\"idx\" [ngClass]=\"[getClass('element', 'group'), getClass('grid', 'group')]\">\n\n            <ng-container *ngTemplateOutlet=\"startTemplate?.templateRef; context: groupModel\"></ng-container>\n\n            <dynamic-material-form-control *ngFor=\"let _model of groupModel.group\"\n                                           [context]=\"groupModel\"\n                                           [group]=\"array.at(idx)\"\n                                           [hidden]=\"_model.hidden\"\n                                           [layout]=\"formLayout\"\n                                           [model]=\"_model\"\n                                           [templates]=\"templates\"\n                                           [hostClass]=\"[getClass('element','children'), getClass('grid','children')]\"\n                                           (blur)=\"onBlur($event)\"\n                                           (change)=\"onChange($event)\"\n                                           (focus)=\"onFocus($event)\"\n                                           (matEvent)=\"onCustomEvent($event, null, true)\"></dynamic-material-form-control>\n\n            <ng-container *ngTemplateOutlet=\"endTemplate?.templateRef; context: groupModel\"></ng-container>\n\n        </div>\n\n    </div>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], templates: [{
            type: Input
        }], components: [{
            type: ViewChildren,
            args: [DynamicMaterialFormControlContainerComponent]
        }] }); })();
class DynamicMaterialFormGroupComponent extends DynamicFormGroupComponent {
    constructor(layoutService, validationService) {
        super(layoutService, validationService);
        this.layoutService = layoutService;
        this.validationService = validationService;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.customEvent = new EventEmitter();
        this.focus = new EventEmitter();
    }
}
DynamicMaterialFormGroupComponent.ɵfac = function DynamicMaterialFormGroupComponent_Factory(t) { return new (t || DynamicMaterialFormGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormLayoutService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormValidationService)); };
DynamicMaterialFormGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialFormGroupComponent, selectors: [["dynamic-material-form-group"]], viewQuery: function DynamicMaterialFormGroupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DynamicMaterialFormControlContainerComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.components = _t);
    } }, inputs: { formLayout: "formLayout", group: "group", layout: "layout", model: "model", templates: "templates" }, outputs: { blur: "blur", change: "change", customEvent: "customEvent", focus: "focus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 8, consts: [[3, "formGroup"], ["role", "group", 3, "formGroupName", "id", "ngClass"], [3, "group", "hidden", "layout", "model", "templates", "hostClass", "blur", "change", "focus", "matEvent", 4, "ngFor", "ngForOf"], [3, "group", "hidden", "layout", "model", "templates", "hostClass", "blur", "change", "focus", "matEvent"]], template: function DynamicMaterialFormGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DynamicMaterialFormGroupComponent_dynamic_material_form_control_2_Template, 1, 9, "dynamic-material-form-control", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroupName", ctx.model.id)("id", ctx.id)("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c1, ctx.getClass("element", "control"), ctx.getClass("grid", "control")));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.model.group);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.FormGroupName, ɵngcc4.NgClass, ɵngcc4.NgForOf, DynamicMaterialFormControlContainerComponent], encapsulation: 2 });
DynamicMaterialFormGroupComponent.ctorParameters = () => [
    { type: DynamicFormLayoutService },
    { type: DynamicFormValidationService }
];
DynamicMaterialFormGroupComponent.propDecorators = {
    formLayout: [{ type: Input }],
    group: [{ type: Input }],
    layout: [{ type: Input }],
    model: [{ type: Input }],
    templates: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    customEvent: [{ type: Output }],
    focus: [{ type: Output }],
    components: [{ type: ViewChildren, args: [DynamicMaterialFormControlContainerComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialFormGroupComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-form-group",
                template: "<ng-container [formGroup]=\"group\">\n\n    <div role=\"group\"\n         [formGroupName]=\"model.id\"\n         [id]=\"id\"\n         [ngClass]=\"[getClass('element', 'control'), getClass('grid', 'control')]\">\n\n        <dynamic-material-form-control *ngFor=\"let _model of model.group\"\n                                       [group]=\"control\"\n                                       [hidden]=\"_model.hidden\"\n                                       [layout]=\"formLayout\"\n                                       [model]=\"_model\"\n                                       [templates]=\"templates\"\n                                       [hostClass]=\"[getClass('element','children'), getClass('grid','children')]\"\n                                       (blur)=\"onBlur($event)\"\n                                       (change)=\"onChange($event)\"\n                                       (focus)=\"onFocus($event)\"\n                                       (matEvent)=\"onCustomEvent($event, null, true)\"></dynamic-material-form-control>\n    </div>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc1.DynamicFormLayoutService }, { type: ɵngcc1.DynamicFormValidationService }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], customEvent: [{
            type: Output
        }], focus: [{
            type: Output
        }], formLayout: [{
            type: Input
        }], group: [{
            type: Input
        }], layout: [{
            type: Input
        }], model: [{
            type: Input
        }], templates: [{
            type: Input
        }], components: [{
            type: ViewChildren,
            args: [DynamicMaterialFormControlContainerComponent]
        }] }); })();

class DynamicMaterialFormComponent extends DynamicFormComponent {
    constructor(changeDetectorRef, componentService) {
        super(changeDetectorRef, componentService);
        this.changeDetectorRef = changeDetectorRef;
        this.componentService = componentService;
        this.blur = new EventEmitter();
        this.change = new EventEmitter();
        this.focus = new EventEmitter();
        this.matEvent = new EventEmitter();
    }
}
DynamicMaterialFormComponent.ɵfac = function DynamicMaterialFormComponent_Factory(t) { return new (t || DynamicMaterialFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DynamicFormComponentService)); };
DynamicMaterialFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicMaterialFormComponent, selectors: [["dynamic-material-form"]], contentQueries: function DynamicMaterialFormComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DynamicTemplateDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templates = _t);
    } }, viewQuery: function DynamicMaterialFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DynamicMaterialFormControlContainerComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.components = _t);
    } }, inputs: { group: "group", model: "model", layout: "layout" }, outputs: { blur: "blur", change: "change", focus: "focus", matEvent: "matEvent" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 2, consts: [[3, "group", "hidden", "layout", "model", "templates", "blur", "change", "focus", "matEvent", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "group", "hidden", "layout", "model", "templates", "blur", "change", "focus", "matEvent"]], template: function DynamicMaterialFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DynamicMaterialFormComponent_dynamic_material_form_control_0_Template, 1, 5, "dynamic-material-form-control", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.model)("ngForTrackBy", ctx.trackByFn);
    } }, directives: [ɵngcc4.NgForOf, DynamicMaterialFormControlContainerComponent], encapsulation: 2, changeDetection: 0 });
DynamicMaterialFormComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: DynamicFormComponentService }
];
DynamicMaterialFormComponent.propDecorators = {
    group: [{ type: Input }],
    model: [{ type: Input }],
    layout: [{ type: Input }],
    blur: [{ type: Output }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    matEvent: [{ type: Output }],
    templates: [{ type: ContentChildren, args: [DynamicTemplateDirective,] }],
    components: [{ type: ViewChildren, args: [DynamicMaterialFormControlContainerComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicMaterialFormComponent, [{
        type: Component,
        args: [{
                selector: "dynamic-material-form",
                template: "<dynamic-material-form-control *ngFor=\"let controlModel of model; trackBy: trackByFn\"\n                               [group]=\"group\"\n                               [hidden]=\"controlModel.hidden\"\n                               [layout]=\"layout\"\n                               [model]=\"controlModel\"\n                               [templates]=\"templates\"\n                               (blur)=\"onBlur($event)\"\n                               (change)=\"onChange($event)\"\n                               (focus)=\"onFocus($event)\"\n                               (matEvent)=\"onCustomEvent($event, matEvent)\"></dynamic-material-form-control>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.DynamicFormComponentService }]; }, { blur: [{
            type: Output
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], matEvent: [{
            type: Output
        }], group: [{
            type: Input
        }], model: [{
            type: Input
        }], layout: [{
            type: Input
        }], templates: [{
            type: ContentChildren,
            args: [DynamicTemplateDirective]
        }], components: [{
            type: ViewChildren,
            args: [DynamicMaterialFormControlContainerComponent]
        }] }); })();

class DynamicFormsMaterialUIModule {
}
DynamicFormsMaterialUIModule.ɵfac = function DynamicFormsMaterialUIModule_Factory(t) { return new (t || DynamicFormsMaterialUIModule)(); };
DynamicFormsMaterialUIModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DynamicFormsMaterialUIModule });
DynamicFormsMaterialUIModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            MatAutocompleteModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDatepickerModule,
            MatIconModule,
            MatInputModule,
            MatRadioModule,
            MatSelectModule,
            MatSliderModule,
            MatSlideToggleModule,
            DynamicFormsCoreModule
        ], DynamicFormsCoreModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicFormsMaterialUIModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    MatAutocompleteModule,
                    MatCheckboxModule,
                    MatChipsModule,
                    MatDatepickerModule,
                    MatIconModule,
                    MatInputModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatSliderModule,
                    MatSlideToggleModule,
                    DynamicFormsCoreModule
                ],
                declarations: [
                    DynamicMaterialCheckboxComponent,
                    DynamicMaterialChipsComponent,
                    DynamicMaterialDatePickerComponent,
                    DynamicMaterialFormArrayComponent,
                    DynamicMaterialFormComponent,
                    DynamicMaterialFormControlContainerComponent,
                    DynamicMaterialFormGroupComponent,
                    DynamicMaterialInputComponent,
                    DynamicMaterialRadioGroupComponent,
                    DynamicMaterialSelectComponent,
                    DynamicMaterialSlideToggleComponent,
                    DynamicMaterialSliderComponent,
                    DynamicMaterialTextAreaComponent
                ],
                entryComponents: [
                    DynamicMaterialCheckboxComponent,
                    DynamicMaterialChipsComponent,
                    DynamicMaterialDatePickerComponent,
                    DynamicMaterialFormArrayComponent,
                    DynamicMaterialFormGroupComponent,
                    DynamicMaterialInputComponent,
                    DynamicMaterialRadioGroupComponent,
                    DynamicMaterialSelectComponent,
                    DynamicMaterialSlideToggleComponent,
                    DynamicMaterialSliderComponent,
                    DynamicMaterialTextAreaComponent
                ],
                exports: [
                    DynamicFormsCoreModule,
                    DynamicMaterialCheckboxComponent,
                    DynamicMaterialChipsComponent,
                    DynamicMaterialDatePickerComponent,
                    DynamicMaterialFormArrayComponent,
                    DynamicMaterialFormComponent,
                    DynamicMaterialFormControlContainerComponent,
                    DynamicMaterialFormGroupComponent,
                    DynamicMaterialInputComponent,
                    DynamicMaterialRadioGroupComponent,
                    DynamicMaterialSelectComponent,
                    DynamicMaterialSlideToggleComponent,
                    DynamicMaterialSliderComponent,
                    DynamicMaterialTextAreaComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicFormsMaterialUIModule, { declarations: function () { return [DynamicMaterialCheckboxComponent, DynamicMaterialChipsComponent, DynamicMaterialDatePickerComponent, DynamicMaterialFormArrayComponent, DynamicMaterialFormComponent, DynamicMaterialFormControlContainerComponent, DynamicMaterialFormGroupComponent, DynamicMaterialInputComponent, DynamicMaterialRadioGroupComponent, DynamicMaterialSelectComponent, DynamicMaterialSlideToggleComponent, DynamicMaterialSliderComponent, DynamicMaterialTextAreaComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatSliderModule,
        MatSlideToggleModule,
        DynamicFormsCoreModule]; }, exports: function () { return [DynamicFormsCoreModule, DynamicMaterialCheckboxComponent, DynamicMaterialChipsComponent, DynamicMaterialDatePickerComponent, DynamicMaterialFormArrayComponent, DynamicMaterialFormComponent, DynamicMaterialFormControlContainerComponent, DynamicMaterialFormGroupComponent, DynamicMaterialInputComponent, DynamicMaterialRadioGroupComponent, DynamicMaterialSelectComponent, DynamicMaterialSlideToggleComponent, DynamicMaterialSliderComponent, DynamicMaterialTextAreaComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DynamicFormsMaterialUIModule, DynamicMaterialCheckboxComponent, DynamicMaterialChipsComponent, DynamicMaterialDatePickerComponent, DynamicMaterialFormArrayComponent, DynamicMaterialFormComponent, DynamicMaterialFormControlContainerComponent, DynamicMaterialFormGroupComponent, DynamicMaterialFormInputControlComponent, DynamicMaterialInputComponent, DynamicMaterialRadioGroupComponent, DynamicMaterialSelectComponent, DynamicMaterialSlideToggleComponent, DynamicMaterialSliderComponent, DynamicMaterialTextAreaComponent, materialUIFormControlMapFn };

